
import DefaultSidebar from '@/components/default-layout/DefaultSidebar.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'default-sidebar-desktop',
  components: { DefaultSidebar },
})
export default class DefaultSidebarDesktop extends Vue {
  get showSidebar(): boolean {
    const name = this.$route.name || '';
    return name.startsWith('project') || name.startsWith('chain');
  }
}
